export default "__VITE_ASSET__BsuD6fqY__"